import { isEmpty } from 'lodash-es';
import { useScopedAppFlagStore } from '@frontend/scope';
import { FeatureFlagStrategy, useAppFlagStore } from '@frontend/shared';
import { FEATURE_FLAG_MAP, FeatureFlagKey } from './feature-flag-registry';

export const createFeatureFlagHook = (flagKey: FeatureFlagKey, strategy: FeatureFlagStrategy = 'ALL') => {
  const config = FEATURE_FLAG_MAP[flagKey];

  if (!config) {
    throw new Error(`Feature flag config not found for key: ${flagKey}`);
  }

  return () => {
    // App flag store
    const { featureFlags } = useAppFlagStore();
    const isFeatureFlagsLoaded = !isEmpty(featureFlags);

    // Scoped feature flag
    const { getFeatureFlagValue } = useScopedAppFlagStore();
    const hasFF = getFeatureFlagValue(config.flagName, strategy);

    const isLoading = !isFeatureFlagsLoaded;
    const isEnabled = !isLoading && hasFF;

    return {
      isLoading,
      isEnabled,
    };
  };
};
